import { useState } from 'react';
import './UnHumanRights.css';

const ARTICLES = [
  { article: 1, title: 'Right to Equality', icon: '⚖️', text: 'All human beings are born free and equal in dignity and rights. They are endowed with reason and conscience and should act towards one another in a spirit of brotherhood.' },
  { article: 2, title: 'Freedom from Discrimination', icon: '🌍', text: 'Everyone is entitled to all the rights and freedoms set forth in this Declaration, without distinction of any kind, such as race, color, sex, language, religion, or origin.' },
  { article: 3, title: 'Right to Life, Liberty & Security', icon: '🛡️', text: 'Everyone has the right to life, liberty and security of person, free from fear, violence, and unlawful harm.' },
  { article: 7, title: 'Equality Before the Law', icon: '🏛️', text: 'All are equal before the law and are entitled without any discrimination to equal protection of the law.' },
  { article: 19, title: 'Freedom of Opinion & Expression', icon: '🗣️', text: 'Everyone has the right to freedom of opinion and expression; this right includes freedom to hold opinions without interference and to seek, receive and impart information.' },
  { article: 26, title: 'Right to Education', icon: '📚', text: 'Everyone has the right to education. Education shall be free, at least in the elementary and fundamental stages, directed to full development of the human personality.' }
];

function UnHumanRights() {
  const [activeArticle, setActiveArticle] = useState(ARTICLES[0]);

  return (
    <div className="page-shell rights-page">
      <div className="page-intro rights-hero">
        <span className="rights-badge">Proclaimed by UN General Assembly 1948</span>
        <h1 className="page-title">Universal Declaration of Human Rights</h1>
        <div className="rights-intro-text">
          <p>
            The Universal Declaration of Human Rights (UDHR) is a milestone document in the history of human rights.
          </p>
          <p>
            Drafted by representatives with different legal and cultural backgrounds from all regions of the world, the Declaration was proclaimed by the United Nations General Assembly in Paris on 10 December 1948 (General Assembly resolution 217 A) as a common standard of achievements for all peoples and all nations.
          </p>
          <p>
            It sets out, for the first time, fundamental human rights to be universally protected and it has been translated into over 500 languages.
          </p>
        </div>
      </div>

      <div className="rights-layout">
        {/* Left Column: Article Selector Cards */}
        <div className="rights-sidebar">
          <h3>Key Articles Spotlight</h3>
          <div className="article-list">
            {ARTICLES.map((art) => (
              <button
                key={art.article}
                type="button"
                className={`article-tab-btn ${activeArticle.article === art.article ? 'active' : ''}`}
                onClick={() => setActiveArticle(art)}
              >
                <span className="art-number">Art. {art.article}</span>
                <span className="art-title">{art.title}</span>
                <span className="art-icon">{art.icon}</span>
              </button>
            ))}
          </div>
        </div>

        {/* Right Column: Display Active Article & UNGDO Role */}
        <div className="rights-content-panel">
          <div className="article-focus-card">
            <div className="focus-header">
              <span className="focus-icon">{activeArticle.icon}</span>
              <div>
                <span className="focus-tag">Article {activeArticle.article}</span>
                <h2>{activeArticle.title}</h2>
              </div>
            </div>
            <blockquote className="article-quote">
              "{activeArticle.text}"
            </blockquote>

            <div className="ungdo-advocacy-box">
              <h4>UNGDO Advocacy & Human Rights Action</h4>
              <p>
                At UNGDO, we champion human rights education, community legal awareness, and social equity programs.
                Working in conjunction with local civil society organizations, we help build resilient communities where every individual’s dignity is honored.
              </p>
              <ul className="advocacy-points">
                <li>Rights Education in schools & community centers</li>
                <li>Advocacy for vulnerable populations & disaster victims</li>
                <li>Support for legal empowerment & social inclusion</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UnHumanRights;
